import * as yup from 'yup';
import {
  requiredImageFromCMSSchema,
  richTextFromCMSSchema,
} from '../../cms/schemas';

export const schema = yup
  .object({
    image: requiredImageFromCMSSchema,
    title: yup.string(),
    explanation: richTextFromCMSSchema,
  })
  .transform(value => ({
    image: value.image,
    title: value.title,
    explanation: value.explanation,
  }));
